module.exports = __webpack_public_path__ + "img/logo.fcc8d2f1.png";